<template>
  <div class="join-us">
    <!-- <div class="join-img">
      <banner-img :type="1" :alt="alt"></banner-img>
    </div> -->
      <div style="width:100%;height:20px;background:#efefef"></div>
      <div class="p">
       <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/productCenter' }">产品中心</el-breadcrumb-item>
          <el-breadcrumb-item>产品列表</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <div class='join-main'>
          <!-- <div class="left-left"></div> -->
         <leftBox class="left"></leftBox>
         <div class="main-right-talented">
          <Right></Right>
        </div>
    </div>
    <div class="rightfixed">
        <ul :class="searchBarFixed == true ? 'isFixed' :''">
           <rightFixed></rightFixed>
        </ul>
    </div>
    <Bottom></Bottom>
  </div>
</template>

<script>
import leftBox from "./components/leftBox"
import rightFixed from "../productCenter/components/rightFixed"
import Right from "./Right"
import Bottom from '../../components/bottom'
export default {
  name: 'join-us',
  data () {
    return {
      searchBarFixed: false,
      offsetTop: 0,
      currentIndex:0,
      alt:'百生跃试剂优惠活动'
    }
  },
  components:{
    Bottom,
    leftBox,
    rightFixed,
    Right
  },
  mounted () {
     window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
      handleScroll () {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        var offsetTop = document.querySelector('.rightfixed').offsetTop
        if (scrollTop > offsetTop) {
          this.searchBarFixed = true
        } else {
          this.searchBarFixed = false
        }
      },
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },  
}
</script>

<style lang="less" scoped>
.join-us{
  width: 1920px;
  min-height: 1335px;
  background: #efefef;
  box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.5); 
  position: relative;
  .rightfixed{
      width: 90px;
      height:230px;
      position: absolute;
      top:550px;
      right:10px;
      .isFixed{
        position:fixed;
        bottom:150px;
        z-index:999;
      }
  }
  .box-one{
      width: 1510px;
      height: 316px;
      background: #f6f6f6;
      margin: auto;
      background: url("../../images/four.png");
  }
  .p{
    font-size: 14px;
    margin:0px 0px 20px 335px;
    color: #666666;
    height:19px;
    line-height: 19px;
    /deep/.el-breadcrumb__inner.is-link{
      color:#666666;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      font-weight: normal;
    }
    /deep/ .el-icon-arrow-right{
      color:#666666;
    }
    /deep/ .el-breadcrumb__inner{
      cursor: pointer;
    }
  }
  .join-main{
    width: 1510px;
    background: #ffffff;
    margin: auto;
    margin-bottom: 20px;
    display: flex;
    .left{
      margin-left: 130px;
      // border-top-right-radius: 10px;
      // border-bottom-right-radius: 10px;
    }
    // .left-left{
    //   border-top-left-radius: 10px;
    //   border-bottom-left-radius: 10px;
    //   margin-left: 110px;
    //   width: 16px;
    //   margin-top: 44px;
    //   margin-bottom: 20px;
    //   background: #ffbb00;
    // }
    .main-right-talented{
      width: 876px;
      background: #ffffff;
      margin-top: 44px;
      margin-left: 61px;
    }
  }
  .join-img{
    width: 100%;
    img{
      width: 1920px;
      height: 300px;
    }
  }
  .five{
    width: 805px;
    height: 49px;
    margin: auto;
    margin-top: 15px;;
    font-size: 14px;
    text-align: center;
    color: #666666;
    line-height: 24px;
    span{
      font-size: 14px;
      text-align: center;
      color: #666666;
      line-height: 24px;
    }
  }
}
</style>